module.exports = __webpack_public_path__ + "img/the-reading.3b019afe.png";